import React from "react";
import Confetti from "react-confetti";

export default function Birthdaycard({ name, age, onClose, photoUrl, show }) {
    const getOrdinalSuffix = (age) => {
  if (age % 100 >= 11 && age % 100 <= 13) {
    return "th";
  }

  switch (age % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        numberOfPieces={500} // more confetti
        gravity={0.15} // slower fall
        wind={0.03} // slight horizontal movement
        recycle={show} // keeps going while visible
        tweenDuration={4000} // smooth animation
        friction={0.99}
      />

      <div className="birthday-overlay">
  <div className="birthday-card">
    <h1>🎉 Happy Birthday 🎉</h1>
{photoUrl && (
  <div className="photo-wrappers">
    <img src={photoUrl} alt={name} />
  </div>
)}
    <h2 className="birthday-name">{name}</h2>

    <p className="birthday-message">
      Wishing you a great <span>{age}{getOrdinalSuffix(age)}</span> Birthday! 🎂
    </p>

    <button className="birthday-button" onClick={onClose}>
      🎁 Thank You
    </button>
  </div>
</div>
    </>
  );
}
